import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  selectViewingsFilters,
  setViewingsAttendeeResponse,
  clearViewingsAttendeeResponse,
} from "../../../redux/slices/filterSlice";
import Button from "../../Button/Button";
import CheckIcon from "../../../assets/svg/check-icon";
import AttendeeResponseBadge from "../../../pages/Crm/components/Viewings/components/AttendeeResponseBadge";
import {
  USER_RESPONSE_FILTER_OPTIONS,
  ATTENDEE_RESPONSE_BADGE_CONFIG,
} from "../../../pages/Crm/components/Viewings/utils/constants";
import {
  isUserResponseOptionSelected,
  toggleUserResponseOption,
} from "../../../pages/Crm/components/Viewings/utils/functions";
import type { AttendeeResponseStatus } from "../../../pages/Crm/components/Viewings/utils/types";

const ViewingsAttendeeResponseFilter = ({
  onClose,
}: {
  onClose: () => void;
}) => {
  const dispatch = useDispatch();
  const attendeeResponse = useSelector(selectViewingsFilters)?.attendeeResponse;

  const [draftSelected, setDraftSelected] = useState<AttendeeResponseStatus[]>(
    (attendeeResponse?.value as AttendeeResponseStatus[]) ?? []
  );

  const handleApply = () => {
    dispatch(
      setViewingsAttendeeResponse({
        value: draftSelected,
        displayValue: draftSelected.map(
          (status) => ATTENDEE_RESPONSE_BADGE_CONFIG[status]?.label ?? status
        ),
      })
    );
    onClose();
  };

  const handleClear = () => {
    setDraftSelected([]);
    dispatch(clearViewingsAttendeeResponse());
    onClose();
  };

  return (
    <div className="flex flex-col gap-2 mt-2">
      <div className="flex flex-col">
        {USER_RESPONSE_FILTER_OPTIONS.map((option) => {
          const checked = isUserResponseOptionSelected(option, draftSelected);
          return (
            <button
              key={option.id}
              type="button"
              onClick={() =>
                setDraftSelected((current) =>
                  toggleUserResponseOption(option, current)
                )
              }
              className="flex items-center justify-between h-[40px] px-3 w-full border-b border-border-gray dark:border-border-gray-dk cursor-pointer hover:bg-hover-effect dark:hover:bg-hover-effect-dk"
            >
              <AttendeeResponseBadge response={option.badgeValue} />
              <span
                aria-hidden
                className={`flex h-[14px] w-[14px] shrink-0 items-center justify-center rounded-[3px] transition-colors ${
                  checked
                    ? "bg-verba-blue dark:bg-verba-blue-dk"
                    : "border border-gray-placeholder dark:border-gray-placeholder-dk bg-popper-bg dark:bg-popper-bg-dk"
                }`}
              >
                {checked && (
                  <CheckIcon className="w-3 h-3 text-pure-white dark:text-pure-white-dk" />
                )}
              </span>
            </button>
          );
        })}
      </div>

      <div className="flex justify-end gap-2 mt-4 px-3">
        <Button
          innerText="Clear"
          onClick={handleClear}
          disabled={(attendeeResponse?.value?.length ?? 0) === 0}
          buttonContainerClass="py-1 px-7.5 border border-verba-indigo dark:border-verba-indigo-dk rounded-lg disabled:opacity-50 disabled:cursor-not-allowed"
          innerTextClass="text-md font-medium whitespace-nowrap text-heading-text dark:text-heading-text-dk"
        />
        <Button
          innerText="Apply"
          onClick={handleApply}
          buttonContainerClass="py-1 px-7.5 rounded-lg bg-verba-indigo dark:bg-verba-indigo-dk disabled:opacity-50 disabled:cursor-not-allowed"
          innerTextClass="text-md font-medium whitespace-nowrap text-pure-white dark:text-pure-white-dk"
        />
      </div>
    </div>
  );
};

export default ViewingsAttendeeResponseFilter;
